export function Trust() {
  return (
    <section
      id="trust"
      aria-labelledby="trust-title"
      className="py-32 md:py-40 bg-slate-950 relative border-t border-white/10 scroll-mt-10 md:scroll-mt-24"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(59,130,246,0.06),transparent_60%)] pointer-events-none"
      />
      <div className="container mx-auto px-6">
        {/* Header */}
        <header className="max-w-4xl mx-auto text-center mb-24">
          <h2
            id="trust-title"
            className="text-4xl md:text-5xl font-bold mb-8 text-white tracking-tight"
          >
            למה לבחור במשרדנו?
          </h2>

          <p
            aria-labelledby="trust-title"
            aria-describedby="trust-desc"
            className="text-xl md:text-2xl text-white/70 font-light max-w-2xl mx-auto leading-relaxed"
          >
            בעולם המשפט, מאחורי כל תיק עומד סיפור אישי. אנו מאמינים שעם הקשבה
            אמיתית, אסטרטגיה מדויקת ונחישות, ניתן להוביל כל מאבק לתוצאה הראויה.
          </p>
        </header>

        {/* Trust List */}
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 text-right">
          <TrustItem
            title="אסטרטגיה מנצחת"
            description="כל תיק מתחיל בהקשבה אמיתית לסיפור שלכם. מתוך הבנה עמוקה של המקרה, אנו בונים אסטרטגיה מדויקת ונחושה שמובילה אתכם בביטחון לעבר התוצאה הנכונה."
            id="strategy"
          />

          <TrustItem
            title="שקט נפשי"
            description="כשאתם מיוצגים על ידינו, אתם לא לבד במאבק. אנו מלווים אתכם אישית בכל שלב, מטפלים בבירוקרטיה ומעניקים לכם ביטחון ושקט בתקופה המורכבת בחייכם."
            id="peace"
          />

          <TrustItem
            title="תוצאות בשטח"
            description="המטרה שלנו ברורה – מיצוי מלא של זכויותיכם והשגת הפיצוי הראוי. אנו פועלים בנחישות ובמקצועיות כדי להבטיח שהתוצאה תשקף באמת את הנזק והמאבק שעברתם."
            id="results"
          />
        </ul>
      </div>
    </section>
  );
}

/* =========================
   Trust Item
========================= */

function TrustItem({
  title,
  description,
  id,
}: {
  title: string;
  description: string;
  id: string;
}) {
  return (
    <li
      className="flex flex-col items-start group"
      aria-labelledby={`trust-${id}-title`}
      aria-describedby={`trust-${id}-desc`}
    >
      {/* Decorative divider */}
      <div
        className="w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8"
        aria-hidden="true"
      />

      <article className="w-full">
        <h3
          id={`trust-${id}-title`}
          className="text-3xl font-bold mb-5 text-white group-hover:text-blue-400 group-focus-within:text-blue-400 transition-all duration-300"
        >
          {title}
        </h3>

        <p
          id={`trust-${id}-desc`}
          className="text-lg text-white/80 leading-relaxed font-light"
        >
          {description}
        </p>
      </article>
    </li>
  );
}
